import { render, staticRenderFns } from "./Post2000-H.vue?vue&type=template&id=77f697f4"
import script from "./Post2000-H.vue?vue&type=script&lang=js"
export * from "./Post2000-H.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports